import "./Division.css";
import { motion } from "framer-motion";
import divisions from "./divisionData";

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const card = {
  hidden: {
    opacity: 0,
    y: 80,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
    },
  },
};

export default function Division() {
  return (
    <section id="projects" className="division-section">

      <motion.h1
        initial={{ opacity: 0, x: -120 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
        className="division-title"
      >
        OUR IGNITE <span>DIVISIONS</span>
      </motion.h1>

      <motion.div
        className="division-grid"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        {divisions.map((item) => (
          <motion.div
            key={item.id}
            variants={card}
            whileHover={{
              scale: 1.05,
              rotateX: 8,
              rotateY: -8,
            }}
            transition={{ type: "spring", stiffness: 200 }}
            className="card"
          >
            <div className="card-inner">

              {/* Front */}

              <div
                className="card-front"
                style={{
                  background:
                    item.id === 1
                      ? "#ff2b2b"
                      : "rgba(255,255,255,.03)",
                }}
              >
                <h2>{item.icon}</h2>
                <h3>{item.title}</h3>
              </div>

              {/* Back */}

              <div className="card-back">

                <h3>{item.title}</h3>

                <h4>{item.subtitle}</h4>

                <p>{item.description}</p>

              </div>

            </div>
          </motion.div>
        ))}
      </motion.div>

    </section>
  );
}